export const otAccordion = {
    init: function () {
        const accordions = document.querySelectorAll('[data-saas-accordion]');

        accordions.forEach(accordion => {
            accordion.querySelectorAll('[data-accordion-target]').forEach(item => {
                const target = accordion.querySelector(item.getAttribute('data-accordion-target'));
                if(!item.classList.contains('active')) {
                    target.style.height = '0px';
                }
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    let button = e.target;
                    // check if button is a button element
                    button = button.tagName === 'BUTTON' ? button : button.closest('button');

                    this.buttonHandler({ button, accordion, item });
                });
            });
        });

    },
    buttonHandler: function ({ button, accordion, item }) {
        const target = accordion.querySelector(item.getAttribute('data-accordion-target'));
        const isOpen = button.classList.contains('active');

        // Check if it is already open
        if(isOpen) return this.close({ button, accordion });

        // Get the old active accordion item
        const previousActive = accordion.querySelector('.active') || null;

        // close the active accordion item
        if(previousActive !== null) this.close({ button: previousActive, accordion });


        this.open({ button, target });
    },
    close: function ({ button, accordion }) {
        button.classList.remove('active');
        const target = accordion.querySelector(button.getAttribute('data-accordion-target'));
        const height = target.scrollHeight;
        target.animate([
            { height: height + 'px' },
            { height: '0px' },
        ], {
            duration: 300,
            easing: 'ease-in-out',
            fill: 'forwards'
        }, function () {
            button.setAttribute('aria-expanded', 'false');
            target.setAttribute('aria-hidden', 'true')
        });
    },
    open: function ({ button, target }) {
        button.classList.add('active');
        const height = target.scrollHeight;
        target.animate([
            { height: '0px' },
            { height: height + 'px' }
        ], {
            duration: 300,
            easing: 'ease-in-out',
            fill: 'forwards'
        })
        button.setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
    }
}
